const CHATBOT_RESET = 'CHATBOT/RESET';

export default function chatbotResetAction () {
  return {
    type: CHATBOT_RESET,
    payload: {}
  };
}

export { CHATBOT_RESET };